export default {"src":"/_next/static/media/script.c1ad6dcd.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};